document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('[data-header-search="trigger"]');
  const overlay = document.querySelector('[data-header-search="overlay"]');
  const closeBtn = document.querySelector('[data-header-search="close"]');
  const input = overlay ? overlay.querySelector('input[type="search"]') : null;

  if (!trigger || !overlay) return;

  function openSearch() {
    // Position overlay below the header
    const header = document.querySelector('.header');
    if (header) {
      overlay.style.top = header.getBoundingClientRect().bottom + 'px';
    }

    overlay.classList.add('is-active');
    document.body.classList.add('search-overlay-open');

    // Focus the input after transition
    setTimeout(function () {
      if (input) input.focus();
    }, 100);
  }

  function closeSearch() {
    overlay.classList.remove('is-active');
    document.body.classList.remove('search-overlay-open');
  }

  trigger.addEventListener('click', function () {
    if (overlay.classList.contains('is-active')) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeSearch);
  }

  // Close on Escape
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
      closeSearch();
      trigger.focus();
    }
  });
});
